module.exports = __webpack_public_path__ + "img/hyu_gallery3.01ada131.jpg";